// extracted by mini-css-extract-plugin
export var avatarContainer = "_h8-0";
export var avatarTypingWave = "_h8-i";
export var gray = "_h8-f";
export var green = "_h8-c";
export var icon = "_h8-9";
export var image = "_h8-1";
export var lg = "_h8-6";
export var md = "_h8-5";
export var presenceDot = "_h8-b";
export var red = "_h8-d";
export var sm = "_h8-4";
export var status = "_h8-a";
export var typingDot = "_h8-h";
export var typingPill = "_h8-g";
export var xl = "_h8-7";
export var xs = "_h8-3";
export var xxl = "_h8-8";
export var xxs = "_h8-2";
export var yellow = "_h8-e";